/**
 * The collection Run collection actually runs.
 *
 * In a cloud (REST) workspace the sidebar holds `GET /collections` — an INDEX:
 * each request is { id, name, method, url, folder_id, settings, sort_order } and
 * nothing else (backend `Collections.format_request_index/1`). The runner ran
 * that index, so every cloud request went out with no body, no headers, no auth
 * and no scripts: a POST with a JSON body got a 422 under Run and a 200 on Send,
 * because opening a request (Send) fetches the full record first. Card 77f785cc.
 *
 * `GET /collections/:id` returns the full records; they get the same mapping the
 * editor uses (`mapApiRequestToSidebar`), so Run sees what Send sees.
 */
import { mapApiRequestToSidebar } from './requestMappers';

/**
 * @param {object} collection  the sidebar collection
 * @param {{ fetchFullCollection?: (id) => Promise<object|null> }} [options]
 *   Given only for cloud REST workspaces; local / sync-engine collections are
 *   already complete in memory.
 * @returns {Promise<object>} the collection to run (throws if the fetch fails)
 */
export async function loadRunnableCollection(collection, { fetchFullCollection } = {}) {
  if (!collection || typeof fetchFullCollection !== 'function') return collection;
  const full = await fetchFullCollection(collection.id);
  if (!full || !Array.isArray(full.requests)) return collection;
  return {
    ...collection,
    settings: full.settings ?? collection.settings,
    requests: full.requests.map(mapApiRequestToSidebar),
  };
}
